import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

/**
 * Consistent top menu bar / page header used across all views.
 * Ensures uniform shadow, height and padding.
 */
@Component({
  selector: 'app-page-header',
  standalone: true,
  templateUrl: './page-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  /** Erlaubt dem projizierten Inhalt, bei zu wenig Platz in eine zweite Zeile umzubrechen,
   * statt (wie im Standardverhalten) auf fester Höhe abgeschnitten zu werden. Opt-in, damit
   * bestehende Seiten mit fixer 72px-Höhe unverändert bleiben. */
  @Input() wrap = false;
}
